// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e0e881cf","667":"e72f6fbe","977":"773fd703"}[chunkId] + ".chunk.js";
};